import { useState } from 'react';
import { occurrenceKeys } from 'utils/occurrence-keys';
import { NOT_AVAILABLE } from './utils';
import styles from './document-card.module.scss';

// Applicable areas shown on the collapsed card column before a "Show more".
const MAX_AREAS = 6;

/**
 * The card's Applicable Areas column: the first MAX_AREAS areas and a "Show
 * more" that reveals the rest in place.
 * @param {object} props The column.
 * @param {string[]} props.areas The area labels.
 * @return {JSX.Element} The column.
 */
export function DocumentCardAreas({ areas }: { areas: string[] }) {
  const [showAll, setShowAll] = useState(false);
  const shown = showAll ? areas : areas.slice(0, MAX_AREAS);
  const keys = occurrenceKeys(shown);
  return (
    <div className={styles.areasCol}>
      <div className={styles.colHeader}>Applicable Areas</div>
      {areas.length > 0 ? (
        <>
          <ul className={styles.areaColList}>
            {shown.map((area, i) => (
              <li key={keys[i]}>{area}</li>
            ))}
          </ul>
          {areas.length > MAX_AREAS && !showAll && (
            <button
              type="button"
              className={styles.viewMore}
              onClick={(e) => {
                e.stopPropagation();
                setShowAll(true);
              }}
            >
              Show more +({areas.length - MAX_AREAS})
            </button>
          )}
        </>
      ) : (
        <span className={styles.muted}>{NOT_AVAILABLE}</span>
      )}
    </div>
  );
}
